import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import HomePage from "./components/HomePage/HomePage";
import Dashboard from "./components/AdminPage/AdminPage";
import Login from "./components/HomePage/Login";
import { AuthProvider, useAuth } from "./components/context/AuthContext";
import PrivateRoute from "./components/context/PrivateRoute";

function AppRoutes() {
  const { isLoggedIn } = useAuth();
  const location = useLocation();

  if (isLoggedIn && location.pathname === "/") {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/admin" element={<Login />} />{" "}
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
